export default {
  actions: {
    PAGE_VIEW: 'page_view',
    BUTTON_CLICK: 'button_click'
  }
}
